import FormField from "common/components/ui/FormField";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "common/components/ui/Select";
import SelectButton from "common/components/ui/SelectButton";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useSalesNavigatorContracts from "common/datahooks/useSalesNavigatorContracts";

import useSalesNavigatorContract from "../../datahooks/useSalesNavigatorContract";
import useSalesNavigatorContractMutations from "../../datahooks/useSalesNavigatorContractMutations";

export default function SalesNavigatorContract({
  accountId,
}: {
  accountId: string;
}) {
  const { permissions } = useSelectedWorkspaceContext();
  const { changeSalesNavigatorContract } = useSalesNavigatorContractMutations();

  const { salesNavigatorContracts, isLoadingSalesNavigatorContracts } =
    useSalesNavigatorContracts(accountId);

  const { salesNavigatorContract, isLoadingSalesNavigatorContract } =
    useSalesNavigatorContract(accountId);

  const isViewOnly = !permissions.includes("accounts_full");
  const isLoading =
    isLoadingSalesNavigatorContract || isLoadingSalesNavigatorContracts;

  const label = isLoading ? "Loading contracts..." : salesNavigatorContract;

  return (
    <FormField
      label="Currently selected contract"
      htmlFor="sales-navigator-contract"
    >
      <Select
        onValueChange={(value) =>
          changeSalesNavigatorContract({
            accountId,
            salesNavigatorContract: value,
          })
        }
        disabled={isLoading || isViewOnly}
        value={salesNavigatorContract}
      >
        <SelectTrigger id="sales-navigator-contract" asChild>
          <SelectButton
            hasSelection={!!salesNavigatorContract}
            isLoading={isLoading}
          >
            {label}
          </SelectButton>
        </SelectTrigger>

        <SelectContent>
          {salesNavigatorContracts?.map(({ name }) => (
            <SelectItem value={name} key={name}>
              {name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormField>
  );
}
